// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"af21f7a0","977":"91f2273e"}[chunkId] + ".chunk.js";
};